export default __webpack_public_path__ + "static/media/banksafe_logo_white.11d11a33.svg";